<div class="states-container">
    <ng-container *ngFor="let estado of estados; let i = index">
        <div class="state-item" [class.last]="i === estados.length - 1">
            <div class="state-node" [class.active]="estado.activado">
                <div class="icon-circle" [class.active]="estado.activado">
                    <span *ngIf="estado.activado" class="mdi mdi-check-circle"></span>
                    <span *ngIf="!estado.activado" class="mdi mdi-circle-outline"></span>
                </div>
                <div class="label">
                    {{estado.nombre}}
                </div>
            </div>
            <div *ngIf="i !== estados.length - 1" class="connector-line" [class.active]="estado.activado"></div>
        </div>
    </ng-container>
</div>